import React, { useState } from 'react';
import { MdCheck } from 'react-icons/md';

const PricingPage = () => {
  const [selectedTab, setSelectedTab] = useState('individual');

  const tiers = {
    individual: [
      {
        name: 'Basic',
        price: 349,
        features: [
          'Access to basic learning materials',
          '6 Weekly Assignments',
          'Comparative Leaderboard',
          'Debates , Passages'
        ]
      },
      {
        name: 'Professional',
        price: 599,
        features: [
          'Access to basic learning materials',
          '12 Weekly Assignments',
          'Comparative Leaderboard',
          'Advanced analytics dashboard',
          'Debates , Passages, Common Qs',
        ]
      }
    ],
    school: [
      {
        name: 'Basic',
        price: 299,
        discount: 15,
        features: [
          'Access to basic learning materials',
          '6 Weekly Assignments',
          'Comparative Leaderboard',
          'Debates , Passages'
        ]
      },
      {
        name: 'Professional',
        price: 499,
        discount: 20,
        features: [
          'Access to basic learning materials',
          '12 Weekly Assignments',
          'Comparative Leaderboard',
          'Advanced analytics dashboard',
          'Debates , Passages, Common Qs',
        ]
      }
    ]
  };

  return (
    <div className="w-full max-w-6xl mx-auto my-8 px-4">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">Choose Your Plan</h1>
        <p className="text-lg text-gray-600">Select the perfect plan for your learning journey</p>
      </div>

      <div className="flex justify-center mb-12">
        <div className="inline-flex rounded-lg bg-gray-100 p-1">
          <button
            className={`px-6 py-2 rounded-lg text-lg font-semibold transition-colors ${
              selectedTab === 'individual'
                ? 'bg-white text-red-600 shadow-sm'
                : 'text-gray-600 hover:text-red-600'
            }`}
            onClick={() => setSelectedTab('individual')}
          >
            Individual
          </button>
          <button
            className={`px-6 py-2 rounded-lg text-lg font-semibold transition-colors ${
              selectedTab === 'school'
                ? 'bg-white text-red-600 shadow-sm'
                : 'text-gray-600 hover:text-red-600'
            }`}
            onClick={() => setSelectedTab('school')}
          >
            School
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
        {tiers[selectedTab].map((tier) => (
          <div
            key={tier.name}
            className="bg-white rounded-lg shadow-lg overflow-visible relative flex flex-col pt-6"
          >
            {tier.discount && (
              <div className="absolute -top-4 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                {tier.discount}% OFF
              </div>
            )}
            
            <div className="px-6 pb-6 border-b border-gray-200">
              <h3 className="text-2xl font-bold text-center text-gray-800 mb-4">{tier.name}</h3>
              <div className="text-center">
                <span className="text-4xl font-bold text-red-600">₹{tier.price}</span>
                <span className="text-gray-600">{selectedTab === 'individual' ? '/month' : '/month/student'}</span>
              </div>
            </div>
            
            <div className="p-6 flex-grow">
              <ul className="space-y-4">
                {tier.features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-3">
                    <MdCheck className="text-green-500 flex-shrink-0" size={20} />
                    <span className="text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="p-6 pt-0">
              <button className="w-full bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition-colors font-semibold">
                Get Started
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingPage;



// import React, { useState } from 'react';
// import { MdCheck } from 'react-icons/md';

// const PricingPage = () => {
//   const [selectedTab, setSelectedTab] = useState('individual');

//   const tiers = {
//     individual: [
//       {
//         name: 'Basic',
//         price: 400,
//         features: [
//           'Access to basic learning materials',
//           'Progress tracking',
//           'Monthly assessments',
//           'Basic analytics'
//         ]
//       },
//       {
//         name: 'Pro',
//         price: 500,
//         features: [
//           'All Basic features',
//           'Advanced learning paths',
//           'Weekly assessments',
//           'Detailed performance analytics',
//           'Priority email support'
//         ]
//       },
//       {
//         name: 'Professional',
//         price: 600,
//         features: [
//           'All Pro features',
//           'Custom learning paths',
//           'Daily assessments',
//           'Advanced analytics dashboard',
//           'Priority 24/7 support',
//           'Personal learning coach'
//         ]
//       }
//     ],
//     school: [
//       {
//         name: 'Basic',
//         price: 300,
//         discount: 25,
//         features: [
//           'Access to basic learning materials',
//           'Progress tracking for all students',
//           'Monthly assessments',
//           'Basic analytics'
//         ]
//       },
//       {
//         name: 'Pro',
//         price: 400,
//         discount: 20,
//         features: [
//           'All Basic features',
//           'Advanced learning paths',
//           'Weekly assessments',
//           'Detailed performance analytics',
//           'Priority email support'
//         ]
//       },
//       {
//         name: 'Professional',
//         price: 500,
//         discount: 17,
//         features: [
//           'All Pro features',
//           'Custom learning paths',
//           'Daily assessments',
//           'Advanced analytics dashboard',
//           'Priority 24/7 support',
//           'Dedicated account manager'
//         ]
//       }
//     ]
//   };

//   return (
//     <div className="w-full max-w-6xl mx-auto my-8 px-4">
//       <div className="text-center mb-12">
//         <h1 className="text-4xl font-bold text-gray-800 mb-4">Choose Your Plan</h1>
//         <p className="text-lg text-gray-600">Select the perfect plan for your learning journey</p>
//       </div>

//       <div className="flex justify-center mb-12">
//         <div className="inline-flex rounded-lg bg-gray-100 p-1">
//           <button
//             className={`px-6 py-2 rounded-lg text-lg font-semibold transition-colors ${
//               selectedTab === 'individual'
//                 ? 'bg-white text-red-600 shadow-sm'
//                 : 'text-gray-600 hover:text-red-600'
//             }`}
//             onClick={() => setSelectedTab('individual')}
//           >
//             Individual
//           </button>
//           <button
//             className={`px-6 py-2 rounded-lg text-lg font-semibold transition-colors ${
//               selectedTab === 'school'
//                 ? 'bg-white text-red-600 shadow-sm'
//                 : 'text-gray-600 hover:text-red-600'
//             }`}
//             onClick={() => setSelectedTab('school')}
//           >
//             School
//           </button>
//         </div>
//       </div>

//       <div className="grid md:grid-cols-3 gap-8">
//         {tiers[selectedTab].map((tier) => (
//           <div
//             key={tier.name}
//             className="bg-white rounded-lg shadow-lg overflow-visible relative flex flex-col pt-6"
//           >
//             {tier.discount && (
//               <div className="absolute -top-4 right-4 bg-red-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
//                 {tier.discount}% OFF
//               </div>
//             )}
            
//             <div className="px-6 pb-6 border-b border-gray-200">
//               <h3 className="text-2xl font-bold text-center text-gray-800 mb-4">{tier.name}</h3>
//               <div className="text-center">
//                 <span className="text-4xl font-bold text-red-600">₹{tier.price}</span>
//                 {/*display /month for individual and /month/student for school*/}
//                 <span className="text-gray-600">{selectedTab === 'individual' ? '/month' : '/month/student'}</span>
//                 {/* <span className="text-gray-600">/month</span> */}
//               </div>
//             </div>
            
//             <div className="p-6 flex-grow">
//               <ul className="space-y-4">
//                 {tier.features.map((feature, index) => (
//                   <li key={index} className="flex items-center gap-3">
//                     <MdCheck className="text-green-500 flex-shrink-0" size={20} />
//                     <span className="text-gray-600">{feature}</span>
//                   </li>
//                 ))}
//               </ul>
//             </div>
            
//             <div className="p-6 pt-0">
//               <button className="w-full bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 transition-colors font-semibold">
//                 Get Started
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default PricingPage;
